export default __webpack_public_path__ + "static/media/sun.0c75c2fc.svg";